import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { onCLS, onFID, onLCP } from "web-vitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  
    <App />
  
);

onCLS(console.log);
onFID(console.log);
onLCP(console.log);
